// eslint-disable-next-line
import { Subject, empty } from 'rxjs';
import keys from 'lodash.keys';
import { map, filter } from 'rxjs/operators';
import { unstable_batchedUpdates } from 'react-dom';
var DefaultSharedStore = /** @class */ (function () {
    function DefaultSharedStore() {
        this.store = {};
        this.subjects = {};
        this.anyChangeSubject = new Subject();
        this.collectionChanges = {};
    }
    DefaultSharedStore.prototype.getValue = function (key) {
        return this.store[key];
    };
    DefaultSharedStore.prototype.setValue = function (key, value) {
        if (this.setStoreValue(key, value)) {
            this.getSubject(key).next(value);
            this.anyChangeSubject.next([key]);
        }
    };
    DefaultSharedStore.prototype.update = function (update) {
        var _this = this;
        var updateKeys = keys(update);
        if (!updateKeys || updateKeys.length < 1)
            return; // noop if no update provided
        var updated = [];
        unstable_batchedUpdates(function () {
            for (var _i = 0, updateKeys_1 = updateKeys; _i < updateKeys_1.length; _i++) {
                var key = updateKeys_1[_i];
                var value = update[key];
                if (_this.setStoreValue(key, value)) {
                    updated.push(key);
                }
            }
            _this.anyChangeSubject.next(updated);
            for (var _a = 0, updated_1 = updated; _a < updated_1.length; _a++) {
                var key = updated_1[_a];
                _this.getSubject(key).next(update[key]);
            }
        });
    };
    DefaultSharedStore.prototype.onChange = function (keys) {
        if (this.isSingleKey(keys)) {
            return this.getSubject(keys);
        }
        else {
            return this.onAnyOfKeysChange(keys);
        }
    };
    /*eslint-enable no-dupe-class-members*/
    DefaultSharedStore.prototype.isSingleKey = function (keys) {
        return typeof keys === 'string';
    };
    DefaultSharedStore.prototype.onAnyChange = function () {
        return this.anyChangeSubject;
    };
    DefaultSharedStore.prototype.delete = function (keys) {
        var _this = this;
        unstable_batchedUpdates(function () {
            keys.forEach(function (key) { return delete _this.store[key]; });
            keys.forEach(function (key) {
                var subject = _this.subjects[key];
                if (subject)
                    subject.next(undefined);
            });
            _this.anyChangeSubject.next(keys);
        });
    };
    DefaultSharedStore.prototype.allKeys = function () {
        return keys(this.store);
    };
    DefaultSharedStore.prototype.hasKey = function (key) {
        return key in this.store;
    };
    DefaultSharedStore.prototype.getSubject = function (key) {
        var subject = this.subjects[key];
        if (subject === undefined) {
            return (this.subjects[key] = new Subject());
        }
        return subject;
    };
    DefaultSharedStore.prototype.setStoreValue = function (key, value) {
        var newValue = this.store[key] !== value;
        if (newValue) {
            this.store[key] = value;
            if (this.isCollection(value)) {
                this.attachCollectionChangeEvents(key, value);
            }
        }
        return newValue;
    };
    DefaultSharedStore.prototype.attachCollectionChangeEvents = function (key, collection) {
        var _this = this;
        var sub = this.collectionChanges[key];
        if (sub)
            sub.unsubscribe();
        this.collectionChanges[key] = collection.onAnyChange().subscribe(function () {
            _this.anyChangeSubject.next([key]);
        });
    };
    DefaultSharedStore.prototype.isCollection = function (value) {
        return value instanceof DefaultSharedStore;
    };
    DefaultSharedStore.prototype.onAnyOfKeysChange = function (keys) {
        if (!keys)
            return empty();
        return this.anyChangeSubject.pipe(filter(function (updated) {
            return updated.some(function (updatedKey) { return keys.some(function (key) { return key === updatedKey; }); });
        }), map(function () {
            /*noop*/
        }));
    };
    return DefaultSharedStore;
}());
export { DefaultSharedStore };
//# sourceMappingURL=default-shared-store.js.map